import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {BaseComponent} from "../../BaseComponent";
import validationEngine from "devextreme/ui/validation_engine";
import {DxFormComponent} from "devextreme-angular";
import {ChangePasswordRequest} from "../../../models/auth/ChangePasswordRequest";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent extends BaseComponent implements OnInit {

  /**
   * Event that tells the father component to destroy this component
   */
  @Output('closeDialog') closeDialog = new EventEmitter();


  /**
   * When true deactivates the form until creation process is completed to avoid duplication for fast clicks
   * @protected
   */
  createRequestSent: boolean;

  changePasswordReq!: ChangePasswordRequest;

  readonly formValidationGroup = 'changePassword';

  isFormValid: boolean;

  @ViewChild(DxFormComponent, {static: false}) form!: DxFormComponent;

  constructor() {
    super();
    this.createRequestSent = false;
    this.isFormValid = false;
  }

  ngOnInit() {
    super.ngOnInit();

    this.changePasswordReq = new ChangePasswordRequest();
    this.changePasswordReq.email = this.gmService.user.username;

  }

  newPasswordValue = () => {
    return this.changePasswordReq.newPassword;
  };

  changePasswordMode = (name: string) => {
    let editor = this.form.instance.getEditor(name);
    if (!!editor) {
      editor.option(
        'mode',
        editor.option('mode') === 'text' ? 'password' : 'text',
      );
    }
  };

  oldPasswordEditorOptions = {
    mode: 'password',
    valueChangeEvent: 'keyup',
    buttons: [
      {
        name: 'oldPassword',
        location: 'after',
        options: {
          icon: 'eyeopen',
          stylingMode: 'text',
          onClick: () => this.changePasswordMode('oldPassword'),
        },
      }
    ],
  };
  newPasswordEditorOptions = {
    mode: 'password',
    valueChangeEvent: 'keyup',
    buttons: [
      {
        name: 'newPassword',
        location: 'after',
        options: {
          icon: 'eyeopen',
          stylingMode: 'text',
          onClick: () => this.changePasswordMode('newPassword'),
        },
      }
    ],
  };
  confirmPasswordEditorOptions = {
    mode: 'password',
    valueChangeEvent: 'keyup',
    buttons: [
      {
        name: 'confirmPassword',
        location: 'after',
        options: {
          icon: 'eyeopen',
          stylingMode: 'text',
          onClick: () => this.changePasswordMode('confirmPassword'),
        },
      }
    ],
  };

  changePassword() {


    if (this.checkFormValidity()) {
      this.createRequestSent = true;
      this.closeDialog.emit(this.changePasswordReq);
    } else if (!!this.changePasswordReq.newPassword && this.changePasswordReq.newPassword !== this.changePasswordReq.confirmPassword) {
      this.toastService.openTranslatedErrorToastMessage('ERROR.PASSWORDS_MISMATCH');
    }

  }

  checkFormValidity() {
    if (!!validationEngine.getGroupConfig(this.formValidationGroup)) {
      if (validationEngine.validateGroup(this.formValidationGroup).isValid) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
}
